exports = module.exports = require("../../../node_modules/.pnpm/css-loader@1.0.1_webpack@4.46.0/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box_box_2jjDp {\n}\n", ""]);

// exports
exports.locals = {
	"box": "box_box_2jjDp"
};